// Lender API — calls the local Mockoon mock server (apps/app/mocks/lendcord.mockoon.json,
// run via `pnpm mock:api`) at API_URL.
// TODO: point API_URL at the real backend (Spring Boot) once the lender
// dashboard has a live API. Call sites elsewhere shouldn't need to change.

import { baseApi } from "@/app/store/baseApi";
import type { PortfolioSummary } from "@/features/dashboard/dashboard.types";

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPortfolioSummary: builder.query<PortfolioSummary, void>({
      query: () => ({ url: "/api/lender/portfolio-summary" }),
      providesTags: ["Portfolio"],
    }),
  }),
});

export const { useGetPortfolioSummaryQuery } = dashboardApi;
